import { buildApiTypes } from '@/modules/Vuex';

export const { actionTypes: API_GET_ACCOUNTS } = buildApiTypes('accounts/API_GET_ACCOUNTS');
export const { actionTypes: API_POST_SET_ACCOUNT } = buildApiTypes('accounts/API_POST_SET_ACCOUNT');

export const SET_STATE_ACCOUNTS = 'accounts/SET_STATE_ACCOUNTS';
export const SET_STATE_ACCOUNT = 'accounts/SET_STATE_ACCOUNT';
